import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "../Pages/Admin/Dashboard";
import AdminLayout from "../Pages/Admin/Layout/AdminLayout";
import UsersList from "../Pages/Admin/Users/List";
import CreateUser from "../Pages/Admin/Users/Create";
import RolesList from "../Pages/Admin/Roles/List";
import AssignPermissions from "../Pages/Admin/Roles/AssignPermissions";
import BrandList from "../Pages/Admin/Brand/List";
import CreateBrand from "../Pages/Admin/Brand/Create";
import ProductCategoryList from "../Pages/Admin/ProductCategory/List";
import CreateProductCategory from "../Pages/Admin/ProductCategory/Create";
import ProductSubCategoryList from "../Pages/Admin/ProductSubCategory/List";
import CreateProductSubCategory from "../Pages/Admin/ProductSubCategory/Create";
import BannerList from "../Pages/Admin/Banner/List";
import CreateBanner from "../Pages/Admin/Banner/Create";
import BlogCategoryList from "../Pages/Admin/BlogCategory/List";
import CreateBlogCategory from "../Pages/Admin/BlogCategory/Create";
import SocialLinkList from "../Pages/Admin/SocialLink/List";
import ContactMessagesList from "../Pages/Admin/ContactMessages/List";
import ReviewsList from "../Pages/Admin/Reviews/List";
import SubscribersList from "../Pages/Admin/Subscribers/List";
import ProductList from "../Pages/Admin/Product/List";
import CreateProduct from "../Pages/Admin/Product/Create";
import BlogList from "../Pages/Admin/Blog/List";
import CreateBlog from "../Pages/Admin/Blog/Create";
import EmailTemplateList from "../Pages/Admin/EmailTemplate/List";
import EmailSend from "../Pages/Admin/EmailTemplate/Send";
import CreateEmailTemplate from "../Pages/Admin/EmailTemplate/Create";
import Settings from "../Pages/Admin/Settings/Index";
import AdminProfile from "../Pages/Admin/Profile/Index";
import WebsiteSettings from "../Pages/Admin/Settings/WebsiteSettings";
import ContactSettings from "../Pages/Admin/Settings/ContactSettings";

import { ROUTE_PATHS } from "../constants/routeConstants";
import AuthLayout from "../Pages/Auth/Layout/AuthLayout";
import Login from "../Pages/Auth/Login";
import ResetPassword from "../Pages/Auth/ResetPassword";
import ChangePassword from "../Pages/Auth/ChangePassword";
import React, { useMemo } from "react";
import { NotFoundException } from "../exceptions/AppExceptions";
import FAQList from "../Pages/Admin/FAQs/list";
import CreateFAQs from "../Pages/Admin/FAQs/Create";

// District 

import DistrictList from "../Pages/Admin/District/List";

// Taluka
import TalukaList from "../Pages/Admin/Taluka/List";
import UnitList from "../Pages/Admin/Unit/List";
import CreateUnit from "../Pages/Admin/Unit/Create";

// Lap Test 
import LabTestList from "../Pages/Admin/LabTest/List";
import CampaignForm from "../Pages/Admin/Campaigns/Create";

// Patient
import PatientList from "../Pages/Admin/Patients/List";
import CreatePatient from "../Pages/Admin/Patients/Create";

import PatientVist from "../Pages/Admin/PatientsVisit/List";
import CreatePatientVisit from "../Pages/Admin/PatientsVisit/Create";

import PatientReferralList from "../Pages/Admin/ReferralList/List";
import CreateReferral from "../Pages/Admin/ReferralList/Create";

import PatientDetails from "../Pages/Admin/Patients/PatientDetails";
import LabReportList from "../Pages/Admin/LabReport/List";
import CreateLabReports from "../Pages/Admin/LabReport/Create";


const AdminRoutes = () => {
  const navigate = useNavigate();
  const containsToken = React.useRef(false);
  const isAuthenticated = React.useCallback(() => {
    const token = Cookies.get("token");
    containsToken.current = false;
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      const isExpired = decoded?.exp * 1000 < Date.now();

      if (isExpired) {
        Cookies.remove("token");
        containsToken.current = false;
        return false;
      }
      containsToken.current = true;
      return true;
    } catch (error) {
      Cookies.remove("token");
      containsToken.current = false;
      return false;
    }
  }, []);

  const _isAuth = useMemo(() => isAuthenticated(), [isAuthenticated]);

  React.useEffect(() => {
    const currPath = window.location.pathname;

    // Only redirect to login if we are on an admin route,
    // NOT already on the login or reset password page, and NOT authenticated.
    const publicAuthRoutes = [ROUTE_PATHS.LOGIN, ROUTE_PATHS.RESET_PASSWORD];
    const isChangePassword = currPath.startsWith("/admin/change-password/");
    if (!containsToken.current && !publicAuthRoutes.includes(currPath) && !isChangePassword && !_isAuth) {
      window.location.href = ROUTE_PATHS.LOGIN;
    }
    const forbidForAuth = ["/login", ROUTE_PATHS.RESET_PASSWORD];
    if (
      containsToken.current &&
      forbidForAuth.some((p) => currPath.includes(p))
    ) {
      window.location.href = ROUTE_PATHS.DASHBOARD;
    }
  }, [_isAuth, navigate]);
  return (
    <Routes>
      {isAuthenticated() ? (
        <Route element={<AdminLayout />}>
          <Route path={ROUTE_PATHS.DASHBOARD} element={<Dashboard />} />
          <Route path={ROUTE_PATHS.USERS} element={<UsersList />} />
          <Route path={ROUTE_PATHS.CREATE_USER} element={<CreateUser />} />
          <Route path={ROUTE_PATHS.ROLES} element={<RolesList />} />
          <Route path={ROUTE_PATHS.DISTRICT_LIST} element={<DistrictList />} />
          <Route path={ROUTE_PATHS.TALUKA_LIST} element={<TalukaList />} />
          <Route path={ROUTE_PATHS.LABTESTLIST} element={<LabTestList />} />
          <Route path={ROUTE_PATHS.LAB_REPORT_LIST} element={<LabReportList />} />
          <Route path={ROUTE_PATHS.LAB_REPORT_CREATE} element={<CreateLabReports />} />
       
        
          <Route path={ROUTE_PATHS.UNIT_LIST} element={<UnitList />} />
          <Route path={ROUTE_PATHS.UNIT_CREATE} element={<CreateUnit />} />
          
          <Route path={ROUTE_PATHS.PATIENT_LIST} element={<PatientList />} />
          <Route path={ROUTE_PATHS.PATIENT_CREATE} element={<CreatePatient />} />

          <Route path={ROUTE_PATHS.PATIENT_VISIT_LIST} element={<PatientVist />} />
          <Route path={ROUTE_PATHS.PATIENT_VISIT_CREATE} element={<CreatePatientVisit />} />

          <Route path={ROUTE_PATHS.REFERREL_LIST} element={<PatientReferralList />} />
          <Route path={ROUTE_PATHS.REFFERAL_CREATE} element={<CreateReferral />} />

          <Route path={ROUTE_PATHS.PATIENT_DETAILS} element={<PatientDetails />} />
       

          <Route
            path={ROUTE_PATHS.ASSIGN_PERMISSIONS}
            element={<AssignPermissions />}
          />
          <Route path={ROUTE_PATHS.BRAND} element={<BrandList />} />
          <Route path={ROUTE_PATHS.CREATE_BRAND} element={<CreateBrand />} />
          <Route path={ROUTE_PATHS.PRODUCT_CATEGORY} element={<ProductCategoryList />} />
          <Route path={ROUTE_PATHS.CREATE_PRODUCT_CATEGORY} element={<CreateProductCategory />} />
          <Route path={ROUTE_PATHS.PRODUCT_SUB_CATEGORY} element={<ProductSubCategoryList />} />
          <Route path={ROUTE_PATHS.CREATE_PRODUCT_SUB_CATEGORY} element={<CreateProductSubCategory />} />
          <Route path={ROUTE_PATHS.BANNER} element={<BannerList />} />
          <Route path={ROUTE_PATHS.CREATE_BANNER} element={<CreateBanner />} />
          <Route path={ROUTE_PATHS.BLOG_CATEGORY} element={<BlogCategoryList />} />
          <Route path={ROUTE_PATHS.CREATE_BLOG_CATEGORY} element={<CreateBlogCategory />} />
          <Route path={ROUTE_PATHS.SOCIAL_LINK} element={<SocialLinkList />} />
          <Route path={ROUTE_PATHS.EMAIL_TEMPLATES} element={<EmailTemplateList />} />
          <Route path={ROUTE_PATHS.EMAIL_SEND} element={<EmailSend />} />
          <Route path={ROUTE_PATHS.CREATE_EMAIL_TEMPLATE} element={<CreateEmailTemplate />} />
          <Route path={ROUTE_PATHS.ADMIN_PROFILE} element={<AdminProfile />} />
          <Route path={ROUTE_PATHS.SETTINGS} element={<Settings />} />
          <Route path={ROUTE_PATHS.WEBSITE_SETTINGS} element={<WebsiteSettings />} />
          <Route path={ROUTE_PATHS.CONTACT_SETTINGS} element={<ContactSettings />} />
          <Route path={ROUTE_PATHS.REVIEWS} element={<ReviewsList />} />
          <Route path={ROUTE_PATHS.CONTACT_MESSAGES} element={<ContactMessagesList />} />
          <Route path={ROUTE_PATHS.SUBSCRIBERS_LIST} element={<SubscribersList />} />
          <Route path={ROUTE_PATHS.PRODUCT} element={<ProductList />} />
          <Route path={ROUTE_PATHS.CREATE_PRODUCT} element={<CreateProduct />} />
          <Route path={ROUTE_PATHS.ADMIN_BLOG} element={<BlogList />} />
          <Route path={ROUTE_PATHS.CREATE_BLOG} element={<CreateBlog />} />
          <Route path={ROUTE_PATHS.FAQS_LIST} element={<FAQList />} />
          <Route path={ROUTE_PATHS.CREATE_FAQS} element={<CreateFAQs />} />
        </Route>
      ) : (
        <Route element={<AuthLayout />}>
          <Route path={ROUTE_PATHS.LOGIN} element={<Login />} />
          <Route path={ROUTE_PATHS.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={ROUTE_PATHS.CHANGE_PASSWORD} element={<ChangePassword />} />
        </Route>
      )}
    </Routes>
  );
};

export default AdminRoutes;
